import { handleActions } from 'redux-actions';
import { setCountry } from '../actions/countryActions';

const defaultState = null

export default handleActions(
    {
        [setCountry](state, action) {
            return { ...state, ...action.payload }
        }
    },
    defaultState,
);
